export default "__VITE_ASSET__BQFBpv5i__"